"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOnColor = exports.getOnColorAPCA = exports.getOnColorWCAG = void 0;
const convert_1 = require("./convert");
/**
 * WCAG
 */
const RED = 0.2126;
const GREEN = 0.7152;
const BLUE = 0.0722;
const GAMMA = 2.4;
function luminanceWCAG(r, g, b) {
    const a = [r, g, b].map((v) => {
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, GAMMA);
    });
    return a[0] * RED + a[1] * GREEN + a[2] * BLUE;
}
function contrastWCAG(rgb1, rgb2) {
    const lum1 = luminanceWCAG(...rgb1);
    const lum2 = luminanceWCAG(...rgb2);
    const brightest = Math.max(lum1, lum2);
    const darkest = Math.min(lum1, lum2);
    return (brightest + 0.05) / (darkest + 0.05);
}
const getOnColorWCAG = (args) => {
    const { bgColor, lightColor, darkColor } = args;
    const bgRgb = (0, convert_1.oklchToRgb)(bgColor);
    const lightRgb = (0, convert_1.oklchToRgb)(lightColor);
    return contrastWCAG([bgRgb.r, bgRgb.g, bgRgb.b], [lightRgb.r, lightRgb.g, lightRgb.b]) > 4.5
        ? lightColor
        : darkColor;
};
exports.getOnColorWCAG = getOnColorWCAG;
/**
 * APCA
 */
function luminanceAPCA(oklch) {
    const { r, g, b } = (0, convert_1.oklchToRgb)(oklch);
    return (0.2126 * Math.pow(r / 255, 2.2) +
        0.7152 * Math.pow(g / 255, 2.2) +
        0.0722 * Math.pow(b / 255, 2.2));
}
const getOnColorAPCA = (args) => {
    const { bgColor, lightColor, darkColor } = args;
    const backgroundLuminance = luminanceAPCA(bgColor);
    const lightLuminance = luminanceAPCA(lightColor);
    const darkLuminance = luminanceAPCA(darkColor);
    const contrastWithLight = Math.abs(lightLuminance - backgroundLuminance);
    const contrastWithDark = Math.abs(darkLuminance - backgroundLuminance);
    return contrastWithLight > contrastWithDark ? lightColor : darkColor;
};
exports.getOnColorAPCA = getOnColorAPCA;
/**
 * General
 */
const getOnColor = (args) => {
    if (args.algorithm === "apca") {
        return (0, exports.getOnColorAPCA)(args);
    }
    else {
        return (0, exports.getOnColorWCAG)(args);
    }
};
exports.getOnColor = getOnColor;
